import React from 'react';
import RichMarkdownEditor from '../RichMarkdownEditor';
import MarkdownView from '../MarkdownView';

export const ContentEditor = ({ draft, onChange, consoleId }) => (
  <div>
    <label className="block mb-2 font-medium">Content:</label>
    <RichMarkdownEditor
      value={draft.content || ''}
      onChange={(content) => onChange({ content })}
      minHeight={380}
      uploadTarget={{ consoleId }}
    />
  </div>
);

export const ContentViewer = ({ item }) => (
  item.content?.trim()
    ? <MarkdownView source={item.content} />
    : <p className="italic text-gray-400">This item has no content yet.</p>
);
